
import { mapGetters } from "vuex";
import Form from "./Form.vue";
import MesaData from "./MesaData";

export default {
  name: "app-restaurante-mesas-create",
  data() {
    return {
      mesa: new MesaData({}),
    };
  },
  components: {
    Form,
  },
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
  },
};
